import { _, helpers, React, ts, ui } from '_core';

import { transform } from './helpers';
import { Params } from './types';
import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  portfolios: string;
  fullScreen: boolean;
  params: Params;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  title: string;
  hasBenchmark: boolean;
  isBasket: boolean;
};

const Chart = ({
  id,
  readOnly,
  fullScreen,
  loadWidgetData,
  portfolios,
  title,
  hasBenchmark,
  isBasket,
  params,
}: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) setData(transform(response.data, hasBenchmark, isBasket, params.showTargetWeight));
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    return nestedBarChartFormat(data, 'end_date');
  }, [data]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat="#.####"
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};
export default Chart;
